export default "__VITE_ASSET__BIBN$Q3s__"